import { render, staticRenderFns } from "./ListPedidos.vue?vue&type=template&id=4f901e8a&scoped=true"
import script from "./ListPedidos.vue?vue&type=script&lang=js"
export * from "./ListPedidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f901e8a",
  null
  
)

export default component.exports